module.exports = "<div #dataR></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/policy/policy.component.html
// module id = ./src/app/policy/policy.component.html
// module chunks = main